import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="relative flex min-h-[68vh] w-full flex-col items-center justify-center overflow-hidden px-4 py-16 text-center">
        <span className="pointer-events-none absolute select-none font-heading text-[7rem] font-semibold leading-none text-background-100 md:text-[13rem]">
          404
        </span>
        <div className="relative z-10">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary-100 text-primary-600">
            <i className="ri-film-line text-2xl" />
          </span>
          <h1 className="mt-5 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            这个页面不在片单里
          </h1>
          <p className="mt-2 text-sm text-foreground-600">
            你访问的地址
            <span className="mx-1.5 rounded-sm bg-background-200 px-1.5 py-0.5 font-mono text-xs text-foreground-800">
              {location.pathname}
            </span>
            可能已经调整或尚未上线。
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              回到首页
            </Link>
            <Link
              to="/movies"
              className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              浏览伦理电影
            </Link>
            <Link
              to="/search"
              className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            >
              全站搜索
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}